<script setup lang="ts">
import type SharedMechanicPicker from '../shared/SharedMechanicPicker.vue';

const modelValue = defineModel<boolean>();
</script>

<template>
  <Drawer
    v-model:visible="modelValue"
    header="Right Sidebar"
    style="width: 30rem;"
    position="right"
  >
    <SharedMechanicPicker />
  </Drawer>
</template>
